/**
 * schemas/expense.ts — บันทึกค่าใช้จ่าย
 *
 * ผู้ใช้กรอก "ยอดที่จ่ายจริง" แล้วบอกว่ารวม VAT แล้วหรือยัง
 * server แยก base/vat ให้เองด้วย computeExpenseAmounts()
 */
import { z } from 'zod';
import { dateInput, dateRangeQuery, money, optionalId, optionalText, paginationQuery, requiredText, vatRate, } from './common.js';
export const expenseInputSchema = z.object({
    date: dateInput,
    title: requiredText('ชื่อรายการค่าใช้จ่าย', 300),
    /** ยอดที่ผู้ใช้กรอก */
    inputAmount: money,
    /** true = ยอดที่กรอกรวม VAT แล้ว */
    inputIncludesVat: z.boolean().default(true),
    /** อัตรา VAT ของรายการนี้ (0 = ไม่มี VAT เช่น ค่าบริการที่ไม่ถูก VAT) */
    vatRate: vatRate.default(7),
    categoryId: optionalId,
    supplierId: optionalId,
    /** ชื่อผู้ขายที่ snapshot ไว้ เผื่อผู้ขายยังไม่อยู่ใน master */
    supplierName: optionalText(200),
    notes: optionalText(1000),
});
export const expenseListQuery = paginationQuery.merge(dateRangeQuery).extend({
    search: optionalText(200),
    categoryId: z.string().trim().optional(),
});
//# sourceMappingURL=expense.js.map